export default __webpack_public_path__ + "static/media/caen15.4f9f179a.jpg";